import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class PlayerCar extends Phaser.GameObjects.Image {
  constructor(scene, x, y) {
    super(scene, x, y, ABCyaPhaser.Images.DEFAULT_ATLAS, 'PlayerCar');
    scene.add.existing(this);

    this.scene = scene;
    this.workingWidth = 0;
    this.workingHeight = 0;
    this.boundries = null;
    this.curY = 0;
    this.vX = 0;
    this.curX = 0;
    this.destX = 0;

    this.vY = 0;
    this.curY = 0;
    this.destY = 0;

    this.minX = 151;
    this.maxX = 889;

    this.vR = 0;
    this.destRotation = 0;

    this.outOfControl = false;
    this.timeOutOfControl = 0;

    this.curX = x;
    this.curY = y;
    this.x = this.curX;
    this.startX = this.curX;
    this.destX = this.curX;
    this.y = this.curY;
    this.startY = this.curY;
    this.destY = this.curY;

    this._angle = 0;
    this.angle = this._angle;

    this.workingWidth = this.getBounds().width;
    this.workingHeight = this.getBounds().height;

    this.setOrigin(.5, .5);

    this.boundries = {
      left: this.x - this.workingWidth / 2,
      right: this.x + this.workingWidth / 2,
      top: this.y - this.workingHeight / 2,
      bottom: this.y + this.workingHeight / 2
    };
  }

  setPos(x, y) {
    this.curX = x;
    this.curY = y;
    this.x = this.curX;
    this.startX = this.curX;
    this.y = this.curY;
    this.startY = this.curY;
    this.boundries = {
      left: this.x - this.workingWidth / 2,
      right: this.x + this.workingWidth / 2,
      top: this.y - this.workingHeight / 2,
      bottom: this.y + this.workingHeight / 2
    };
  };

  steer(value) {
    if (this.outOfControl || this.isResetting) return;
    this.destX = this.startX + (value * -1);
    if (this.destX < this.minX) this.destX = this.minX;
    if (this.destX > this.maxX) this.destX = this.maxX;
    if (this.destX > this.x) {
      this.vX = 380;
    }
    else if (this.destX < this.x) {
      this.vX = -380;
    }
  };

  hitOil() {
    this.outOfControl = true;
    this.destRotation = 720;
    this.vR = 760;
    this._angle = this.angle;
  };

  hitTraffic() {
    if (this.isResetting) return;
    this.isResetting = true;
    this.x = this.scene.mid.x + 6;
    this.destRotation = 0;
    this.angle = 0;
    this.destX = this.x;

    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 320, { alpha: 0.2 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this, 320, { alpha: 0.8 }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(this, 320, { alpha: 0.2 }, Phaser.Math.Easing.Linear, () => {
          ABCyaPhaser.Tweens.addTween(this, 320, { alpha: 0.8 }, Phaser.Math.Easing.Linear, () => {
            ABCyaPhaser.Tweens.addTween(this, 320, { alpha: 0.5 }, Phaser.Math.Easing.Linear, () => {
              ABCyaPhaser.Tweens.addTween(this, 320, { alpha: 1 }, Phaser.Math.Easing.Linear, () => {
                this.resetFinished();
              });
            });
          });
        });
      });
    });
  };

  resetFinished() {
    this.isResetting = false;
  };

  update(e) {
    const dtime = e / 1000;
    this.x += this.vX * dtime;

    if (this.vX > 0) {
      if (this.x > this.destX) {
        this.x = this.destX;
        this.vX = 0;
      }
    }
    else if (this.vX < 0) {
      if (this.x < this.destX) {
        this.x = this.destX;
        this.vX = 0;
      }
    }

    let dist = this.destX - this.x;
    const test = dist / Math.abs(dist);

    if (!this.outOfControl) {
      dist = Math.abs(dist);

      if (dist > 0) {
        this.vR = test * 100;
        this.destRotation = 30 * test;
        this.destRotation = 15 * test;
      }
      else {
        this.destRotation = 0;
      }
    }
    else {
      if (this._angle === this.destRotation) {
        this.outOfControl = false;
      }
    }

    this._angle += this.vR * dtime;
    if (this.vR > 0) {
      if (this._angle > this.destRotation) {
        this._angle = this.destRotation;
      }
    }
    else if (this.vR < this.destRotation) {
      if (this._angle < this.destRotation) {
        this._angle = this.destRotation;
      }
    }
    this.angle = this._angle;

    this.boundries = {
      left: this.x - this.workingWidth / 2,
      right: this.x + this.workingWidth / 2,
      top: this.y - this.workingHeight / 2,
      bottom: this.y + this.workingHeight / 2
    };
  };
}